import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 26 2019
 * @author Tomáš Leity
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
export var DPImportTreeNode =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPImportTreeNode, _DomainObject);

  function DPImportTreeNode(path, name, type, status, created, started, finished, requestId) {
    var _this;

    _classCallCheck(this, DPImportTreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPImportTreeNode).call(this));
    _this.path = path;
    _this.name = name;
    _this.type = type;
    _this.status = status;
    _this.created = created;
    _this.started = started;
    _this.finished = finished;
    _this.requestId = requestId;
    return _this;
  }

  return DPImportTreeNode;
}(DomainObject);